module.exports = __webpack_public_path__ + "static/media/conga.ffd9df06.svg";